/**
 * Created by wangmc on 2017/9/7.
 */

import {domain, SGPOSTFIX} from 'teld-web-component/lib/env'

const FIX = domain + SGPOSTFIX

const CMSSG = `//cmsapisg${FIX}`
const BISG = `//bisg${FIX}`
const USERAPISG = `//userapisg${FIX}`
const BASESG = `//basesg${FIX}`
const HLHTSG = `//hlhth5${FIX}`
const RRCSG = `rrcsg${FIX}`
const USERSG =`//userapisg${FIX}`
const sig = `//sgi${FIX}`
const ATMSSG = `////atmsapisg${FIX}`
const MALLAPI = `//mallapi${FIX}`
// const  sig = "https:sgi.teld.cn/api/invoke?SID="
export const baseURL = {

    WX: `//wx${domain}`,
    //官网地址
    "OfficialWebsite": `//www${domain}`,
    //资源服务器地址
    "resourceAddr": `//resource${domain}/`
}

export const SG = {
    //微信分享接口
    'ShareWX':`${baseURL.WX}/api/Ticket`,
    // 配置接口事例
    'GetActivityInfoList': `${CMSSG}CMS-GetActivityInfoList`,
    // 获取活动赠送值
    'PostActivityInfo': `${BISG}FCPBI-PostActivityInfo`,
    // 验证手机号
    'CheckUserExistByMobile': `${USERAPISG}UserAPI-WEBUI-CheckUserExistByMobile`,
    // 获取账户信息
    'GetAccount': `${BASESG}BaseApi-GetAccount`,
    // 充值返现活动主题
    'GetChargeingActivity': `${CMSSG}CMS-GetChargeingActivity`,
    // 获取广告图片
    'GetAppAd': `${CMSSG}CMS-GetAppAd`,

    //月充电花费
    'GetCustomerMonthCharge': `${BISG}FCPBI-GetCustomerMonthCharge`,
    //月充电电量
    'GetCustomerMonthPower': `${BISG}FCPBI-GetCustomerMonthPower`,
    //日充电电量和充电花费趋势图
    'GetCustomerMonthChargeCostDetail': `${BISG}FCPBI-GetCustomerMonthChargeCostDetail`,
    //充电类型对比数据（交流直流）
    'GetCustomerMonthChargeType': `${BISG}FCPBI-GetCustomerMonthChargeType`,
    //月充值详情
    'GetCustomerMonthPayDetail': `${BISG}FCPBI-GetCustomerMonthPayDetail`,
    //减少碳排放量
    'GetCustomerMonthCO2': `${BISG}FCPBI-GetCustomerMonthCO2`,
    //比油车多行驶距离
    'GetCustomerMonthMoreTravel': `${BISG}FCPBI-GetCustomerMonthMoreTravel`,
    //比油车少支付金额
    'GetCustomerMonthLessPayment': `${BISG}FCPBI-GetCustomerMonthLessPayment`,
    //经常去的电站热力图
    'GetCustomerMonthOftenGoStation': `${BISG}FCPBI-GetCustomerMonthOftenGoStation`,
    //获取本月充值方式
    'GetCustomerMonthPayWay': `${BISG}FCPBI-GetCustomerMonthPayWay`,

    // app中嵌入页面-->发现
    'GetActivityInfoList': `${CMSSG}CMS-GetActivityInfoList`,
    //app中嵌入页面-->活动
    'GetActivityByPage': `${CMSSG}CMS-GetActivityByPage`,

    /************************第三方H5 Start***************************/
    // 验证身份
    QueryUserIdentity: `${HLHTSG}/gh5/v1/query_user_identity`,
    // 获取电站详情
    QueryPileList: `${HLHTSG}/gh5/v1/query_PileList`,
    // 获取终端详情
    QueryPileStatus: `${HLHTSG}/gh5/v1/query_pile_status`,
    // 操作地锁
    QueryLock: `${HLHTSG}/gh5/v1/query_Lock`,
    // 开启充电
    StartCharge: `${HLHTSG}/gh5/v1/start_charge`,
    // 获取充电中数据
    QueryChargeStatus: `${HLHTSG}/gh5/v1/query_charge_status`,
    // 结束充电
    EndChargeHlht: `${HLHTSG}/gh5/v1/end_charge`,

    // 获取订单详情 by ID
    GetChargeDetailByID: `${HLHTSG}BSSSD-GetChargeDetailByID`,
    // 获取订单详情 by Code
    GetChargeDetailByCode: `${HLHTSG}BSSSD-GetChargeDetailByCode`,
    // 获取账户信息
    GetCashBalanceByCustomerId: `${HLHTSG}ASCSG-GetCashBalanceByCustomerId`,
    // 获取支付金额
    GetChargeBillDeductAboutWhole: `${HLHTSG}BSSSD-GetChargeBillDeductAboutWhole`,
    // 支付（收款单）
    ManualPayment: `${HLHTSG}BSSSD-ManualPayment`,
    // 调起支付
    PersonRechargeViaThirdPay: `${RRCSG}BossRRC-IRRCRechargeBizSG-PersonRechargeViaThirdPay`,
    // 充值
    // PersonRechargeViaThirdPayByToken: `${RRCSG}/api/invoke?SID=BossRRC-PersonRechargeViaThirdPayByToken`,
    // 获取未支付订单
    GetUnReceivePayBillByCustIDForApp: `${HLHTSG}BSSSD-GetUnReceivePayBillByCustIDForApp`,
    /************************第三方H5 End*****************************/

    //系统发布管理
    GetSysRelease:`${CMSSG}CMS-GetSysReleaseVersionsByID`,

    /**************************plus会员 接口**************************************/
    //二微码注册-获取短信验证码
    getSmsCode: `${USERSG}UserAPI-WEBUI-SendSMSCodeWithGVCode`,
    //二微码注册-验证码短信验证码
    //图形验证码的获取
    'GetGVCode': `${USERSG}UserAPI-WEBUI-GetGVCode`,
    //二微码注册-注册()
    'QRCodeRegister': `${USERSG}UserAPI-WEBUI-RegistWithVCode`,

    //获取RSA加密参数
    'GetRSAParameters': `${USERSG}UserAPI-WEBUI-GetRSAParameters`,

    //**********************************新CV发现页面*******************************************
    // 获取新闻重构页活动
     'GetSelectedActivities': `${CMSSG}CMS-GetSelectedActivities`,
    // 'GetSelectedActivities': `http://cmsapisg.wyqcd.net/api/invoke?SID=CMS-GetSelectedActivities`,
    //新闻列表
    "GetNewsAPP":`${CMSSG}CMS-GetNewsAPP`,
    //新闻咨询
    "GetNewsInformation":`${CMSSG}CMS-GetNewsInformation`,
    "GetOneNewsInformation":`${CMSSG}CMS-GetOneNewsInformation`,

    //**********************************PLUS会员相关接口*********************************************
    // 体验页面  plus专享API
    "DuibaHots":`${ATMSSG}ATMS-DuibaHots`,
    //会员中心页面 数据展示
    "PlusProfile":`${ATMSSG}ATMS-PlusProfile`,
    //购买记录
    "PlusOrders":`${ATMSSG}ATMS-PlusOrders`,
    //邀请记录
    "InviteRecords":`${ATMSSG}ATMS-InviteRecords`,
    //体验页面。商城PLUS商品展示
    "PlusPriceActivity":`${MALLAPI}Mall-Goods-GetGoodsListWithinTeldPlusPriceActivity`,
    //优惠券列表
    "ObtainCoupon":`${ATMSSG}ATMS-ObtainCoupon`,
    //领取优惠券
    "PickupCoupon":`${ATMSSG}ATMS-PickupCoupon`,
    //支付成功的领券列表API
    "GetPickupCouponCurr":`${ATMSSG}ATMS-GetPickupCouponCurr`,
    //注册登陆接口
    "LoginWithVCode":`${USERSG}UserAPI-WEBUI-LoginWithVCode`,

    //**************************充电中增加广告位************************
    "GetStationAds":`${CMSSG}CMS-GetStationAds`,
}



// WEBPACK FOOTER //
// ./src/service/config.js